/* BREEZY DIGITAL — interactions */
(function(){
  "use strict";
  function ready(fn){ document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var nav=document.getElementById('mainNav'), burger=document.getElementById('burger');
    if(burger&&nav){ burger.addEventListener('click',function(){nav.classList.toggle('open');}); }

    /* smooth scroll for same-page hash links */
    document.addEventListener('click',function(e){
      var a=e.target.closest('a[href]'); if(!a) return;
      var href=a.getAttribute('href'); if(!href||href.indexOf('#')===-1) return;
      var hash=href.substring(href.indexOf('#')); if(hash.length<2) return;
      var path=href.split('#')[0];
      if(!(path===''||path==='/'||path===window.location.pathname)) return;
      var target=document.getElementById(hash.slice(1)); if(!target) return;
      e.preventDefault();
      target.scrollIntoView({behavior:'smooth',block:'start'});
      if(history.replaceState){history.replaceState(null,'',hash);}
      if(nav){nav.classList.remove('open');}
    });

    /* active nav highlight */
    var links=[].slice.call(document.querySelectorAll('.main-nav a[href*="#"]')), map={};
    links.forEach(function(l){var h=l.getAttribute('href');var id=h.substring(h.indexOf('#')+1);var el=document.getElementById(id);if(el)map[id]=l;});
    var ids=Object.keys(map);
    if('IntersectionObserver' in window && ids.length){
      var o=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){ids.forEach(function(id){map[id].classList.toggle('is-active',id===en.target.id);});}});},{rootMargin:'-45% 0px -50% 0px'});
      ids.forEach(function(id){o.observe(document.getElementById(id));});
    }

    /* faq */
    document.querySelectorAll('.qa button').forEach(function(b){b.addEventListener('click',function(){b.parentElement.classList.toggle('open');});});

    /* reveal */
    if('IntersectionObserver' in window){
      var r=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');r.unobserve(e.target);}});},{threshold:.12});
      document.querySelectorAll('.rev').forEach(function(el){r.observe(el);});
    } else { document.querySelectorAll('.rev').forEach(function(el){el.classList.add('in');}); }

    /* product variant price */
    var vs=document.getElementById('variant-id'), pe=document.getElementById('product-price');
    if(vs&&pe){vs.addEventListener('change',function(){var o=vs.options[vs.selectedIndex];if(o.getAttribute('data-price'))pe.textContent=o.getAttribute('data-price');});}

    /* product thumbnails */
    var mi=document.getElementById('main-image');
    if(mi){document.querySelectorAll('.thumbs img').forEach(function(t){t.addEventListener('click',function(){mi.src=t.getAttribute('data-full')||t.src;});});}
  });
})();
